module.exports = __webpack_public_path__ + "static/media/1.ready.d097d8c5.jpg";